export * from './alert.service';
export * from './authentication.service';
export * from './user.service';
export * from './sdgcomponent.service';
export * from './result.service';
export * from './summary.service';
export * from './add-question.service'
export * from './feedback.service'
export * from './team-members.service'
export * from './resource.service'



// WEBPACK FOOTER //
// ./src/app/_services/index.ts